import React from 'react'
import { scaleDimensions, getHexColor } from '../utils'
import { OneColorLogoProps } from './LogoTypes'

export const GooglePlayMinimalLogo: React.FC<OneColorLogoProps> = ({ height = 32, color = 'white', className }) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(height, 32, 32)
  const hex = getHexColor(color)

  return (
    <svg
      className={className}
      width={scaledWidth}
      height={scaledHeight}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.882 23.8472L16.0022 17.5705L13.6145 14.9261L4.882 23.8472ZM0.820349 0.743699C0.691247 0.972892 0.612915 1.2369 0.612915 1.52992V23.4701C0.612915 23.8762 0.765227 24.2244 0.99442 24.5L12.0581 13.1999L0.820349 0.743699ZM23.068 11.4186L19.1906 9.22965L15.2421 13.2637L18.0722 16.4014L23.068 13.5829C23.2745 13.4804 23.4519 13.3275 23.5837 13.1384C23.7156 12.9492 23.7976 12.7299 23.8223 12.5007C23.7976 12.2715 23.7156 12.0522 23.5837 11.8631C23.4519 11.6739 23.2745 11.5211 23.068 11.4186ZM17.0989 8.04887L3.72443 0.5L13.6842 11.539L17.0989 8.04887Z"
        fill={hex}
      />
    </svg>
  )
}
